import React from 'react';
import { Badge } from '../ui/badge';
import { STATUS_LABELS, TIPO_LABELS } from '../../lib/format';

export const StatusBadge = ({ status }) => {
  const label = STATUS_LABELS[status] || status;
  if (status === 'finalized') {
    return (
      <Badge data-testid={`status-badge-${status}`} className="bg-primary/15 text-primary border border-primary/30 hover:bg-primary/15">
        {label}
      </Badge>
    );
  }
  if (status === 'review') {
    return (
      <Badge data-testid={`status-badge-${status}`} className="bg-[hsl(var(--info)/0.18)] text-[hsl(var(--info))] border border-[hsl(var(--info)/0.35)] hover:bg-[hsl(var(--info)/0.18)]">
        {label}
      </Badge>
    );
  }
  return (
    <Badge data-testid={`status-badge-${status}`} variant="secondary" className="bg-muted text-muted-foreground border border-border hover:bg-muted">
      {label}
    </Badge>
  );
};

const TIPO_STYLES = {
  construccion_prefab: 'bg-primary/15 text-primary border-primary/30',
  fotovoltaico: 'bg-[hsl(var(--warning)/0.15)] text-[hsl(var(--warning))] border-[hsl(var(--warning)/0.35)]',
  contenedor: 'bg-[hsl(var(--info)/0.15)] text-[hsl(var(--info))] border-[hsl(var(--info)/0.35)]',
};

export const TipoBadge = ({ tipo }) => (
  <Badge data-testid={`tipo-badge-${tipo}`} className={`border hover:bg-transparent ${TIPO_STYLES[tipo] || 'bg-muted text-muted-foreground border-border'}`}>
    {TIPO_LABELS[tipo] || tipo}
  </Badge>
);
